module.exports = __webpack_public_path__ + "media/images/photos/header-bg-5bcba1fe230ba14dc69b291da0e6c033.jpg";